import { render } from "./ListCutiSetujuView.vue?vue&type=template&id=33ba5cb0"
import script from "./ListCutiSetujuView.vue?vue&type=script&lang=js"
export * from "./ListCutiSetujuView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__